// src/components/store/LatestNewsBlogs.tsx
"use client";

import BlogSectionRenderer from "./sections/blog-posts";

export default function LatestNewsBlogs(props: any) {
  return <BlogSectionRenderer {...props} />;
}
export * from "./sections/blog-posts";
